import { render } from "./SendLinkMail.vue?vue&type=template&id=b51f37ac&ts=true"
import script from "./SendLinkMail.vue?vue&type=script&lang=ts"
export * from "./SendLinkMail.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__